import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from 'react-router-dom'; // Import useParams to get the SubCategory ID from the URL

const FromEditSubCategory = () => {
  document.title = "Edit Sub Category | Uma Classes";
  const { id } = useParams(); // Get SubCategory ID from URL parameters

  const [formData, setFormData] = useState({
    name: "",
    category: "", // Category ID here
  });

  const [categories, setCategories] = useState([]); // State to store categories fetched from API
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message

  // Fetch categories and SubCategory details on component mount
  useEffect(() => {
    const fetchCategoriesAndSubCategory = async () => {
      try {
        const token = localStorage.getItem('token');

        // Fetch categories
        const categoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCategories(categoriesResponse); // Assuming the response contains an array of categories

        // Fetch SubCategory details
        const subCategoryResponse = await axios.get(`https://uma.aasmo.in/api/admin/getbyid-subcategory/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Set SubCategory data to form state
        const subCategoryData = subCategoryResponse; // Adjusted to get the correct data
        setFormData({
          name: subCategoryData.name,
          category: subCategoryData.category._id, // Set the category ID to match with dropdown
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching categories or SubCategory details:", error);
        setLoading(false);
      }
    };

    fetchCategoriesAndSubCategory();
  }, [id]); // Fetch categories and SubCategory details when the component mounts

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.put(`https://uma.aasmo.in/api/admin/update-subcategory/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });
      setSuccessMessage("SubCategory Edited successfully");
      setErrorMessage(""); // Clear any previous error messages
    } catch (error) {
      console.error("Error Editing SubCategory:", error);
      setSuccessMessage(""); // Clear any previous success messages
      setErrorMessage("Error Editing SubCategory");
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optional: Edit a loading spinner or message
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="SubCategory" breadcrumbItem="Edit" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-2 col-form-label">
                        SubCategory Name
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="category" className="col-md-2 col-form-label">
                        Category
                      </label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="category"
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                        >
                          <option value="">Select Category</option>
                          {categories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <button type="submit" className="btn btn-primary">Edit</button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FromEditSubCategory;
